export const ACTION_CODE = 'SENIORITY' + '_ACTION';
